module.exports = __webpack_public_path__ + "img/icon-fb.08e096a1.svg";